module.exports = __webpack_public_path__ + "img/lb7.c6513fca.svg";